import React from 'react';
import { K } from '../constants';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[HydroCalc] Uncaught render error:', error, info);
    this.setState({ info });
  }

  reset = () => {
    this.setState({ error: null, info: null });
  };

  reload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.error) return this.props.children;

    const msg = this.state.error?.message || String(this.state.error);
    const stack = this.state.info?.componentStack || this.state.error?.stack || '';

    return (
      <div style={{
        minHeight: '100vh', background: K.bg, color: K.t0,
        fontFamily: "'DM Mono', monospace",
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 24,
      }}>
        <div style={{
          maxWidth: 480, width: '100%',
          background: K.bg1, border: `2px solid ${K.bad}`, borderRadius: 12,
          padding: 24,
        }}>
          <div style={{
            fontFamily: "'Exo 2', sans-serif", fontSize: 22, fontWeight: 800,
            color: K.bad, marginBottom: 8,
          }}>
            Something broke
          </div>
          <div style={{ fontSize: 12, color: K.t2, marginBottom: 16, lineHeight: 1.6 }}>
            HydroCalc hit an unexpected error and stopped this screen. Your incident data and saved settings are not affected.
          </div>

          <div style={{
            background: K.bg2, border: `1px solid ${K.bdr}`, borderRadius: 6,
            padding: '10px 12px', marginBottom: 16,
            fontSize: 11, color: K.t1, fontFamily: 'monospace',
            wordBreak: 'break-word', maxHeight: 120, overflowY: 'auto',
          }}>
            {msg}
          </div>

          <div style={{ display: 'flex', gap: 8 }}>
            <button
              onClick={this.reset}
              style={{
                flex: 1, background: K.bg2, border: `1px solid ${K.bdr2}`, color: K.t1,
                padding: '12px 14px', borderRadius: 8, cursor: 'pointer',
                fontFamily: "'DM Mono', monospace", fontSize: 12, fontWeight: 700,
                letterSpacing: 1, textTransform: 'uppercase',
              }}
            >
              Try again
            </button>
            <button
              onClick={this.reload}
              style={{
                flex: 1, background: K.red, border: `1px solid ${K.red}`, color: '#f5f5f5',
                padding: '12px 14px', borderRadius: 8, cursor: 'pointer',
                fontFamily: "'DM Mono', monospace", fontSize: 12, fontWeight: 700,
                letterSpacing: 1, textTransform: 'uppercase',
              }}
            >
              Reload app
            </button>
          </div>

          {stack && (
            <details style={{ marginTop: 16 }}>
              <summary style={{ fontSize: 10, color: K.t3, cursor: 'pointer', letterSpacing: 1, textTransform: 'uppercase' }}>
                Tech details
              </summary>
              <pre style={{
                fontSize: 10, color: K.t3, marginTop: 8,
                whiteSpace: 'pre-wrap', wordBreak: 'break-word',
                maxHeight: 200, overflowY: 'auto',
              }}>{stack}</pre>
            </details>
          )}
        </div>
      </div>
    );
  }
}
